module.exports = __webpack_public_path__ + "static/media/Lopunny_gaussian2.0859f414.png";